import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { remote_search_update } from '@/state/search/remote_search_update';

import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';

interface Props {
  item: DTOSearchSettings;
}

export const SButtonHistoryListItemUpdateVisibility: React.FC<Props> = ({ item }) => {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const onClick = async (e: React.MouseEvent) => {
    e.stopPropagation();

    let item_new = item.clone({ is_hidden: !item.is_hidden });

    await dispatch(remote_search_update(item_new));
  };

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      className="w-7"
      size="square-5"
      variant="no-border-on-component"
      onClick={onClick}
      iconClassNameBase={`!w-3.5 !h-3.5 `}
      iconClassNameHovered="!text-bar-foreground"
      iconClassNameNonHovered="!text-bar"
      Icon={item.is_hidden ? ICON__eye_solid : ICON__eye_slash_solid}
    />
  );
};
